import React from 'react';
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';

function Counter() {  
    return (
        <>
            <section>
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-12">
                            <div className="mb-5">
                                <h2>
                                    Buy with confidence, it’s backed by experts.
                                </h2>
                                <p className="lead mb-0">
                                    <h3>
                                        <span className="font-w-4 d-block">We deliver unmatched coverage, detail and clarity </span>
                                        <span className="font-w-4 d-block">wherever you are!</span>
                                    </h3>
                                </p>
                                <p className='mt-4'><Link className="btn btn-dark " to="quotation">Order Your Inspection</Link></p>
                            </div>
                        </div>
                    </div>                   

                    <div className="row align-items-center text-center">
                    <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                        <div className="p-6" style={{ backgroundColor: '#d0faec' }}>
                            <div className='row'>
                                <div className='col-4'> <div className="f-icon-l">
                                    {/* Replace "flaticon-friendship" with the actual class for the friendship icon */}
                                    <i className="la la-clipboard-check"></i>
                                </div></div>
                                <div className='col-8'>
                                    <div className="counter">
                                        <div className="counter-desc text-dark">
                                            <CountUp className="count-number h2" end={200} duration={3} />
                                            <span className="h2">+</span>
                                            <h6 className="text-muted mb-0">Inspection Points</h6>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
                        <div className="p-6" style={{ backgroundColor: '#fff5d9' }}>
                            <div className='row'>
                                <div className='col-4'> <div className="f-icon-l">
                                    {/* Replace "flaticon-friendship" with the actual class for the friendship icon */}
                                    <i className="la la-camera"></i>
                                </div></div>
                                <div className='col-8'>
                                    <div className="counter">
                                        <div className="counter-desc text-dark">
                                            <CountUp className="count-number h2" end={40} duration={4} />
                                            <span className="h2">+</span>
                                            <h6 className="text-muted mb-0">Photos per Report</h6>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                        <div className="p-6" style={{ backgroundColor: '#d3f6fe' }}>
                            <div className='row'>
                                <div className='col-4'> <div className="f-icon-l">
                                    {/* Replace "flaticon-friendship" with the actual class for the friendship icon */}
                                    <i className="la la-map-marked"></i>
                                </div></div>
                                <div className='col-8'>
                                    <div className="counter">
                                        <div className="counter-desc text-dark">
                                            <CountUp className="count-number h2" end={500} duration={2} />
                                            <span className="h2">+</span>
                                            <h6 className="text-muted mb-0">Cities Covered</h6>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Counter;
